import { history } from './';
const hasPath = (path) => {
	return history.location.pathname.includes(path);
};

export default hasPath;
